import * as Sentry from '@sentry/react'
import {
  shouldBlockManualSolveraComponentSelection,
  SOLVERA_MANUAL_SELECTION_BLOCKED_MESSAGE,
} from 'projectSections/sections/design/systems/solveraComponentCode'
import { showStudioDesignWarning } from 'projectSections/sections/design/systems/studioComponentLock'
import { StudioComponentItem } from 'types/global'

export const handleAddComponent = (type: string, uuid?: string, params?: any): StudioComponentItem | undefined => {
  var target = uuid ? window.editor.objectByUuid(uuid) : undefined
  // var commandUUID = window.Utils.generateCommandUUIDOrUseGlobal()

  if (uuid && !target) {
    Sentry.captureException(
      new Error(`Unable to find target parent object with uuid=${uuid}. Abort handleAddComponent.`)
    )
    return undefined
  }

  let addedObject

  switch (type) {
    case 'inverter':
      if (params?.inverterId == null) return
      addedObject = new OsInverter({ ...(params || {}), inverter_id: params.inverterId })
      window.editor.execute(new window.AddObjectCommand(addedObject, target, false))
      break
    case 'mppt':
      const inverterData = target.getComponentData()
      const mpptCount = target.mppts?.().length || 0

      if (mpptCount >= inverterData.mppt_quantity && !target.microinverter) {
        console.warn('MPPT limit reached — not adding')
        return
      }
      addedObject = new OsMppt({
        groupColorIndex: OsMppt.allocateGroupColorIndex(target.getSystem()),
      })
      window.editor.execute(new window.AddObjectCommand(addedObject, target, false))
      window.editor.execute(new window.AddObjectCommand(new OsString(), addedObject, true))
      break
    case 'string':
      addedObject = new OsString()
      window.editor.execute(new window.AddObjectCommand(addedObject, target, true))
      break
    case 'moduleGrid':
      window.editor.controllers['AddObject'].start('OsModuleGrid')
      break
    case 'battery':
      if (params?.batteryId == null) return
      addedObject = new OsBattery({
        ...(params || {}),
        battery_id: params.batteryId,
      })
      window.editor.execute(new window.AddObjectCommand(addedObject, target, false))
      break
    case 'other':
      var otherComponentId = params?.otherId
      var otherType = window.AccountHelper.getOtherById(otherComponentId)

      if (
        shouldBlockManualSolveraComponentSelection({
          componentType: 'other',
          code: otherType?.code,
          autoAdded: params?.autoAdded,
          authoredBy: params?.authored_by,
        })
      ) {
        showStudioDesignWarning(SOLVERA_MANUAL_SELECTION_BLOCKED_MESSAGE)
        return undefined
      }

      if (otherType?.other_component_type === 'dc_optimizer') {
        addedObject = window.editor.selectedSystem.addDcOptimizer(otherComponentId, undefined, !!params?.autoAdded)
        break
      }

      const existingComponent = window.editor.selectedSystem
        .others()
        .find((other) => other.other_id === otherComponentId)

      const shouldSetAutoMode = !existingComponent && params?.autoAdded

      addedObject = new window.OsOther({
        other_id: otherComponentId,
        add_mode: shouldSetAutoMode ? window.OsOther.ADD_MODE.AUTO : window.OsOther.ADD_MODE.MANUAL,
        ...(params || {}),
      })

      window.editor.execute(new window.AddObjectCommand(addedObject, target, false))
      break
    default:
    //
  }
  return addedObject
}
